import React from "react";

import { OffersBody } from "@src/features/offers/Offers.body";
import { SiteContentBody } from "@src/features/siteContent/SiteContent.body";

export const SiteContentRoute = () => {
  return <SiteContentBody />;
};
